import { Component, Input, ElementRef, ViewChild, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-custom-tooltip',
  template: `
    <span
      class="tooltip-trigger"
      (mouseenter)="showTooltip()"
      (mouseleave)="hideTooltip()"
      #trigger
    >
      <ng-content></ng-content>
      @if (showDefaultIcon) {
      <mat-icon size="16" color="accent" class="default-tooltip-icon">{{ icon }}</mat-icon>
      }
    </span>
    <div
      class="custom-tooltip"
      [class.visible]="isVisible"
      #tooltip
      [innerHTML]="content"
    ></div>
  `,
  styleUrls: ['./custom-tooltip.component.scss'],
  standalone: false,
})
export class CustomTooltipComponent implements AfterViewInit {
  @Input() content: string = '';
  @Input() icon: string = 'info_outline'; // Default info icon
  @Input() showDefaultIcon: boolean = true; // Show default icon unless custom content is provided
  @ViewChild('tooltip', { static: true }) tooltipElement!: ElementRef;
  @ViewChild('trigger', { static: true }) triggerElement!: ElementRef;

  isVisible = false;

  ngAfterViewInit() {
    // Position tooltip relative to trigger
    this.positionTooltip();
  }

  showTooltip() {
    this.isVisible = true;
    setTimeout(() => this.positionTooltip(), 0);
  }

  hideTooltip() {
    this.isVisible = false;
  }

  private positionTooltip() {
    if (!this.tooltipElement || !this.triggerElement) return;

    const triggerRect = this.triggerElement.nativeElement.getBoundingClientRect();
    const tooltipEl = this.tooltipElement.nativeElement;

    // Find the icon element to align tooltip to it specifically
    const iconElement =
      this.triggerElement.nativeElement.querySelector('.default-tooltip-icon');
    let targetRect = triggerRect;

    if (iconElement) {
      targetRect = iconElement.getBoundingClientRect();
    }

    // Center tooltip above the icon
    const targetCenter = targetRect.left + targetRect.width / 2;
    const tooltipLeft = targetCenter - tooltipEl.offsetWidth / 2;

    tooltipEl.style.left = `${tooltipLeft}px`;
    tooltipEl.style.top = `${targetRect.top - tooltipEl.offsetHeight - 8}px`;
  }
}
